import { hasCookie } from 'cookies-next';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LogoutUserState } from '../store/Slicer/UserSlice';
import axios from 'axios';
import { setPurposeCard } from '../store/Slicer/GroupAdmin';
function ProtectedRoutes({ router, children }) {
  const dispatch = useDispatch();

  const { user, isAuthenticated, login } = useSelector((state) => state.user);
  const userLoggedIn = hasCookie('AUTHKEY');
  const userLoggedIn2 = hasCookie('AUTHKEY2');
  const { purposeCard } = useSelector((state) => state.GetCount);

  const logout = async () => {
    const userdeletecookie = await axios.get('/bizcareui/api/auth/logout');
  };
  useEffect(() => {
    if (!user && router?.pathname !== '/') {
      dispatch(LogoutUserState());
      router.push('/');
    }
    // if(router?.pathname !== '/'){

    // }
  }, [router]);
  const abc = router?.pathname !== '/servicenumber/[id]';
  useEffect(() => {
    if (router?.pathname !== '/servicenumber/[id]' && purposeCard?.mobileNum) {
      dispatch(setPurposeCard({ dropdownChoice: '', mobileNum: '' }));
    }
  }, [abc]);
  if (
    (userLoggedIn === false &&
      router?.pathname !== '/' &&
      isAuthenticated &&
      user?.role === 'PIC') ||
    (userLoggedIn2 === false &&
      router?.pathname !== '/' &&
      isAuthenticated &&
      user?.role === 'Admin')
  ) {
    logout();
    dispatch(LogoutUserState());
    router.push('/');
  }
  if (
    (user?.role === 'PIC' &&
      router?.pathname === '/' &&
      isAuthenticated &&
      userLoggedIn) ||
    (user?.role === 'PIC' &&
      router?.pathname === '/Celcom_dashboard' &&
      isAuthenticated &&
      userLoggedIn)
  ) {
    console.log('ManageCompany');
    router.push('/ManageCompany');
  } else if (
    (user?.role === 'Admin' &&
      router?.pathname === '/' &&
      isAuthenticated &&
      userLoggedIn2) ||
    (user?.role === 'Admin' &&
      router?.pathname === '/ManageCompany' &&
      isAuthenticated &&
      userLoggedIn2)
  ) {
    console.log('inelseif');
    router.push('/Celcom_dashboard');
  }
  return children;
}

export default ProtectedRoutes;
